import { useConfig } from "../contexts/ConfigContext";

export function AnnouncementBar() {
  const { purchases_enabled } = useConfig();
  const items = purchases_enabled ? [
    "🎁 Buy 3, get 1 FREE mixed chamoy surprise",
    "👑 Join the Chamoy Club · 4 candies monthly for $20",
    "💡 Suggest a candy — we might just make it",
    "🔥 100% Mexican spices · Family-run",
    "🚚 Free shipping over $50",
  ] : [
    "🚀 Online orders launching soon — join the waitlist below",
    "💬 DM @alekastreatsllc on TikTok or Instagram to buy today",
    "🔥 100% Mexican spices · Family-run",
    "💡 Suggest a candy — we might just make it",
    "🌶 New chilito candies drop every week",
  ];
  return (
    <div className={`${purchases_enabled ? "bg-[#D32F2F]" : "bg-[#1A1A1A]"} text-white overflow-hidden border-b border-[#1A1A1A]/20`} data-testid="announcement-bar">
      <div className="flex whitespace-nowrap animate-marquee py-2 text-xs uppercase tracking-[0.25em] font-heading">
        {[...items, ...items, ...items].map((t, i) => (
          <span key={i} className="mx-8 shrink-0">{t}</span>
        ))}
      </div>
    </div>
  );
}
